/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  StatsQueryBatchRequest,
  StatsQueryBatchResponse,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Execute one or more aggregation queries on entity data in a single request.

Send an array of 1-25 queries. Each query runs independently and results are returned in the same order.

**Available tables**: invoices, estimates, credit_notes, advance_invoices, payments, customers, items

**Metric types**: count, sum, avg, min, max

**Virtual fields for group_by**:
- `month` - Extract month from date (YYYY-MM)
- `year` - Extract year from date (YYYY)
- `overdue_bucket` - Invoice aging bucket (current, 1-30, 31-60, 61-90, 90+)

**Example — single query (monthly revenue)**:
```json
[{
  "metrics": [{ "type": "sum", "field": "total_with_tax", "alias": "revenue" }],
  "table": "invoices",
  "date_from": "2024-01-01",
  "filters": { "is_draft": false, "voided_at": null },
  "group_by": ["month"]
}]
```

**Example — multi query (dashboard counts)**:
```json
[
  { "metrics": [{ "type": "count", "alias": "total" }], "table": "invoices" },
  { "metrics": [{ "type": "count", "alias": "total" }], "table": "customers" }
]
```
 * @summary Query entity stats (batch)
 */
export type queryEntityStatsResponse200 = {
  data: StatsQueryBatchResponse
  status: 200
}

export type queryEntityStatsResponse400 = {
  data: Error
  status: 400
}

export type queryEntityStatsResponse401 = {
  data: Error
  status: 401
}

export type queryEntityStatsResponse403 = {
  data: Error
  status: 403
}

export type queryEntityStatsResponse404 = {
  data: Error
  status: 404
}

export type queryEntityStatsResponse422 = {
  data: ValidationError
  status: 422
}

export type queryEntityStatsResponse500 = {
  data: Error
  status: 500
}

export type queryEntityStatsResponseSuccess = (queryEntityStatsResponse200) & {
  headers: Headers;
};
export type queryEntityStatsResponseError = (queryEntityStatsResponse400 | queryEntityStatsResponse401 | queryEntityStatsResponse403 | queryEntityStatsResponse404 | queryEntityStatsResponse422 | queryEntityStatsResponse500) & {
  headers: Headers;
};

export type queryEntityStatsResponse = (queryEntityStatsResponseSuccess | queryEntityStatsResponseError)

export const getQueryEntityStatsUrl = () => {


  

  return `/stats/query`
}

export const queryEntityStats = async (statsQueryBatchRequest: StatsQueryBatchRequest, options?: RequestInit): Promise<queryEntityStatsResponse> => {
  
  return customFetch<queryEntityStatsResponse>(getQueryEntityStatsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      statsQueryBatchRequest,)
  }
);}
  

